import React from 'react'

const PlayOffsTournamentComponent = () => {
  return (
    <div>PlayOffsTournamentComponent</div>
  )
}

export default PlayOffsTournamentComponent